import { Controller } from '@hotwired/stimulus'

/**
 * Periodically reloads a Turbo Frame and handles visibility changes
 * to pause refreshing when the tab is inactive.
 */
export default class extends Controller {
    static values = { interval: { type: Number, default: 30 * 1000 } }

    connect() {
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
        document.addEventListener('visibilitychange', this.handleVisibilityChange)

        if (document.visibilityState === 'visible') {
            this.startTimer()
        }
    }

    disconnect() {
        this.stopTimer()
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    }

    handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
            this.refresh()
            this.startTimer()
        } else {
            this.stopTimer()
        }
    }

    startTimer() {
        this.stopTimer() // Prevent multiple timers
        this.timer = setInterval(() => {
            this.refresh()
        }, this.intervalValue)
    }

    stopTimer() {
        if (this.timer) clearInterval(this.timer)
    }

    refresh() {
        if (!this.element || this.element.tagName !== 'TURBO-FRAME') return

        if (this.element.src) {
            this.element.reload()
        } else {
            // If no src is set, it loaded from the initial page.
            // We set it to current URL to allow subsequent reloads.
            this.element.src = window.location.href
        }
    }
}
